const STRING = 1;
const INTEGER = 2;
const REFERENCE = 3;
const BOOLEAN = 4;
const DATE = 5;
const DATETIME = 6;
const FLOAT = 7;
const COLOUR = 8;
const GEOMETRY = 9;
const BLOB = 10;
const DECIMAL = 11;
const TIME = 12;


export {
	STRING,
	INTEGER,
	REFERENCE,
	BOOLEAN,
	DATE,
	DATETIME,
	FLOAT,
	COLOUR,
	GEOMETRY,
	BLOB,
	DECIMAL,
	TIME
}